import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '/api',
});

export const sendMessage = (message) =>
  api.post('/chat/', { message });

export const uploadDocument = (file) => {
  const formData = new FormData();
  formData.append('document', file);
  return api.post('/documents/upload/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const fetchChats = () => api.get('/chats/');
